// https://owlcarousel2.github.io/OwlCarousel2/demos/demos.html
$('document').ready(function () {
	$('.logos-block-slider').owlCarousel({
		loop: true,
		autoplay: true,
		autoplayTimeout: 3000,
		autoplaySpeed: 1000,
		autoplayHoverPause: false,
		margin: 40,
		nav: false,
		dots: false,
		responsive: {
			0: {
				items: 3,
			},
			576: {
				items: 4,
			},
			992: {
				items: 6,
			},
			2000: {
				items: 6,
			}
		}
	});

	$('.news-slider').owlCarousel({
		loop: false,
		autoplay: false,
		margin: 40,
		nav: true,
		dots: true,
		responsive: {
			0: {
				items: 1,
				nav: false,
				stagePadding: 30,
				margin: 10,
			},
			576: {
				items: 2,
				nav: false,
			},
			992: {
				items: 3,
			},
			2000: {
				items: 3,
			}
		}
	});

	$('.quote-slider').owlCarousel({
		loop: false,
		autoplay: false,
		margin: 40,
		nav: false,
		dots: true,
		responsive: {
			0: {
				items: 1,
				nav: false,
				stagePadding: 30,
				margin: 10,
			},
			576: {
				items: 2,
				nav: false,
			},
			992: {
				items: 3,
			},
			2000: {
				items: 3,
			}
		}
	});

	$('.cards-slider').owlCarousel({
		loop: true,
		autoplay: false,
		margin: 15,
		nav: true,
		dots: false,
		responsive: {
			0: {
				items: 1,
				nav: false,
			},
			576: { // sm
				items: 1,
				nav: false,
			},
			768: { // md
				items: 2,
				nav: false,
			},
			992: { // lg
				items: 2,
			},
			1200: { // xl
				items: 4,
			}
		}
	});


	$('.howitworks-slider').owlCarousel({
		loop: false,
		autoplay: false,
		margin: 40,
		nav: false,
		dots: true,
		responsive: {
			0: {
				items: 1,
				nav: false,
				stagePadding: 30,
				margin: 10,
			},
			576: {
				items: 2,
				nav: false,
			},
			992: {
				items: 3,
			},
			2000: {
				items: 3,
			}
		}
	});

	$('.testimonial-slider').owlCarousel({
		loop: false,
		loop: true,
		autoplay: true,
		autoplayTimeout: 7000,
		autoplaySpeed: 1000,
		margin: 40,
		nav: true,
		dots: true,
		items: 1,
		responsive: {
			0: {
				nav: false,
				stagePadding: 0,
				margin: 10,
			},
			576: {
				nav: true,
			},
		}
	});

	$('.image-block-slider').owlCarousel({
		loop: true,
		margin: 15,
		dots: true,
		items: 1,
		responsive: {
			0: {
				stagePadding: 30,
				items: 1,
			},
			992: {
				stagePadding: 160,
				items: 1,
			},
		}
	});

});
